import { defineMessages } from 'react-intl';

const messages = defineMessages({
  amountPaid: {
    description: 'ordersGrid.columns.amountPaid',
    defaultMessage: 'Amount Paid',
    id: 'w6avTR',
  },
});

export default messages;
